import { useRef } from 'react';

import type { IconProps } from './base';
import { BaseIcon } from './base';

export type IconAiAgentVariant = 'solid' | 'gradient';

export type IconAiAgentProps = IconProps & {
  variant?: IconAiAgentVariant;
};

let nextGradientId = 0;

export function IconAiAgent({ variant = 'solid', ...props }: IconAiAgentProps) {
  const gradientIdRef = useRef<string | null>(null);
  if (gradientIdRef.current === null) {
    nextGradientId += 1;
    gradientIdRef.current = `ai-agent-gradient-${nextGradientId}`;
  }

  const gradientId = gradientIdRef.current;

  const fill = variant === 'gradient' ? `url(#${gradientId})` : 'currentColor';

  return (
    <BaseIcon {...props}>
      <path
        d="M14.7071 4.29289C14.4211 4.00689 13.991 3.92134 13.6173 4.07612C13.2437 4.2309 13 4.59554 13 5V8C13 8.38003 13.2154 8.72722 13.5559 8.89598C14.0477 9.13973 14.3193 9.32316 14.5164 9.51813C14.708 9.70763 14.881 9.95965 15.0913 10.4174C15.2544 10.7724 15.6093 11 16 11H19C19.4045 11 19.7691 10.7564 19.9239 10.3827C20.0787 10.009 19.9931 9.57889 19.7071 9.29289L14.7071 4.29289Z"
        fill={fill}
      />
      <path
        d="M14 12C14 10.8972 13.1028 10 12 10C10.8972 10 10 10.8972 10 12C10 13.1028 10.8972 14 12 14C13.1028 14 14 13.1028 14 12Z"
        fill={fill}
      />
      <path
        d="M19.9239 13.6173C20.0787 13.991 19.9931 14.4211 19.7071 14.7071L14.7071 19.7071C14.4211 19.9931 13.991 20.0787 13.6173 19.9239C13.2436 19.7691 13 19.4045 13 19V16C13 15.6093 13.2276 15.2544 13.5826 15.0913C14.0403 14.881 14.2924 14.7079 14.4819 14.5164C14.6768 14.3193 14.8603 14.0477 15.104 13.5559C15.2728 13.2154 15.62 13 16 13H19C19.4045 13 19.7691 13.2436 19.9239 13.6173Z"
        fill={fill}
      />
      <path
        d="M4.07618 10.3827C3.9214 10.009 4.00695 9.57889 4.29295 9.29289L9.29295 4.29289C9.57895 4.00689 10.0091 3.92134 10.3827 4.07612C10.7564 4.2309 11.0001 4.59554 11.0001 5V8C11.0001 8.39071 10.7725 8.74564 10.4175 8.90872C9.95971 9.11898 9.70769 9.29208 9.51819 9.48364C9.32322 9.68074 9.13978 9.95231 8.89604 10.4441C8.72728 10.7846 8.38009 11 8.00006 11H5.00006C4.5956 11 4.23096 10.7564 4.07618 10.3827Z"
        fill={fill}
      />
      <path
        d="M9.29292 19.7071C9.57892 19.9931 10.009 20.0787 10.3827 19.9239C10.7564 19.7691 11 19.4045 11 19L11 16C11 15.62 10.7846 15.2728 10.4441 15.104C9.95234 14.8603 9.68076 14.6768 9.48367 14.4819C9.29211 14.2924 9.11901 14.0403 8.90875 13.5826C8.74567 13.2276 8.39074 13 8.00003 13H5.00003C4.59557 13 4.23093 13.2436 4.07615 13.6173C3.92137 13.991 4.00692 14.4211 4.29292 14.7071L9.29292 19.7071Z"
        fill={fill}
      />

      {variant === 'gradient' ? (
        <defs>
          <linearGradient
            id={gradientId}
            x1="4"
            y1="4"
            x2="22.9528"
            y2="14.835"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#63D6FA" />
            <stop offset="1" stopColor="#E039CE" />
          </linearGradient>
        </defs>
      ) : null}
    </BaseIcon>
  );
}
